import React, { useRef, useState, useEffect} from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import logo from "../assets/logo.png";
import Ar from "../assets/Ar.svg";
import { Link } from "react-router-dom";
import down from "../assets/Down.svg";
import pic from "../assets/Pic.png";
import right from "../assets/Right.svg";
import { toast, ToastContainer } from "react-toastify";
import contact from "../assets/Contact.svg";
import trans from "../assets/Transport.svg";
import asset from "../assets/Asset.svg";
import gate from "../assets/Gate.svg";
import sign from "../assets/Sign.svg";
import dock from "../assets/Dock.svg";
import scrab from "../assets/Scrap.svg";
import work from "../assets/Work.svg";
import order from "../assets/Order.svg";
import riarr from "../assets/Rightarr.svg";
import one from "../assets/One.svg";
import two from "../assets/Two.svg";
import three from "../assets/Three.svg";
import four from "../assets/Four.svg";
import five from "../assets/Five.svg";
import six from "../assets/Six.svg";
import icon from "../assets/Icon.png";
import img1 from "../assets/Img1.svg";
import img2 from "../assets/Img2.svg";
import img3 from "../assets/Img3.svg";
import lar from "../assets/Lar.svg";
import r1 from "../assets/R1.svg";
import r2 from "../assets/R2.svg";
import r3 from "../assets/R3.svg";
import r4 from "../assets/R4.svg";
import group from "../assets/Group.png";
import back from "../assets/Background.svg";
import big from "../assets/Bigimg.png";
import large from "../assets/Large.png";
import large1 from "../assets/Large1.png";
import large2 from "../assets/Large2.png";
import g1 from "../assets/Group1.png";
import g2 from "../assets/Group2.png";
import g3 from "../assets/Group3.png";
import l1 from "../assets/Latest1.png";
import l2 from "../assets/Latest2.png";
import l3 from "../assets/Latest3.png";
import calendar from "../assets/Calender.png";
import factory from "../assets/Factory.png";
import fly from "../assets/Fly.png";
import w from "../assets/W.png";
import t from "../assets/T.png";
import c from "../assets/C.png";
import star from "../assets/Star.png";
import phone from "../assets/Phone.png";
import c1 from "../assets/Car1.png";
import c2 from "../assets/Car2.png";
import c3 from "../assets/Car3.png";
import c4 from "../assets/Car4.png";
import c5 from "../assets/Car5.png";
import c6 from "../assets/Car6.png";
import c7 from "../assets/Car7.png";
import c8 from "../assets/Car8.png";
import c9 from "../assets/Car9.png";
import c10 from "../assets/Car10.png";
import c11 from "../assets/Car11.png";
import close from "../assets/Close.png";
import o1 from "../assets/O1.png";
import o2 from "../assets/O2.png";
import o3 from "../assets/O3.png";
import o4 from "../assets/O4.png";
import o5 from "../assets/O5.png";
import news from "../assets/News.png";
import mail from "../assets/Mail.png";
import backdo from "../assets/Do.png";
import insta from "../assets/Insta.png";
import face from "../assets/Facebook.png";
import youtube from "../assets/Youtube.png";
import link from "../assets/Link.png";
import twit from "../assets/Twit.png";
import n1 from "../assets/N1.png";
import n2 from "../assets/N2.png";
import n3 from "../assets/N3.png";
import n4 from "../assets/N4.png";
import n5 from "../assets/N5.png";
import n6 from "../assets/N6.png";
import trial from "../assets/Trial.png";
import nr from "../assets/Nr.png";
import bus from "../assets/Bus.png";
import q from "../assets/Q.png";
import tg from "../assets/Tick.png";
import n from "../assets/N.png";
import ee from "../assets/Email.png";
import "../components/Button.css";



import g   from "../assets/G.png";      // 82×82
import b8  from "../assets/B8.png";     // 57×56
import y  from "../assets/Y.png";     // 88×89
import s from "../assets/S.png";             // 151×187
import bi      from "../assets/Bi.png";     // 1190×768 (trimmed screenshot)
import mai    from "../assets/Mai.png";          // 852×768 (trimmed screenshot)
import person        from "../assets/person.png";            // 768×1062 (transparent bg)
import bgCircle      from "../assets/Bgc.png"; 
import manufacturing      from "../assets/Manufacturing.png"; 
import warehouse      from "../assets/WareHouse.png"; 
import log     from "../assets/Log.png"; 



const injectKeyframes = () => {
  const css = `
    @keyframes spin      { to { transform: rotate(360deg); } }
    @keyframes blink     { 50% { opacity: .35; } }
    @keyframes floatY    { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-12px); } }
  `;
  const styleTag   = document.createElement("style");
  styleTag.innerHTML = css;
  document.head.appendChild(styleTag);
  return () => document.head.removeChild(styleTag);
};

const imgStyle = {
  position: "absolute",
  pointerEvents: "none",   // purely decorative
  userSelect: "none"
};




const Navbar = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState("Home");
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredIndex1, setHoveredIndex1] = useState(null);
  const days = ["TUE", "WED", "THU", "FRI", "SAT", "SUN", "MON"];
   useEffect(injectKeyframes, []);




// function generateCaptcha() {
//   return Math.random().toString(36).substring(2, 7).toUpperCase();
// }

// // 2️⃣  Helper to paint the captcha
// function drawCaptcha(text) {
//   const canvas = canvasRef.current;
//   if (!canvas) return;                          // guard against null
//   const ctx = canvas.getContext("2d");

//   ctx.clearRect(0, 0, canvas.width, canvas.height);
//   ctx.fillStyle = "#ffffff";
//   ctx.fillRect(0, 0, canvas.width, canvas.height);

//   // letters
//   for (let i = 0; i < text.length; i++) {
//     const x = 20 + i * 20;
//     const y = 30 + Math.random() * 8;
//     const angle = (Math.random() - 0.5) * 0.5;

//     ctx.save();
//     ctx.translate(x, y);
//     ctx.rotate(angle);
//     ctx.font = "bold 22px Arial";
//     ctx.fillStyle = "#0A3A72";
//     ctx.fillText(text[i], 0, 0);
//     ctx.restore();
//   }

//   // noise-lines
//   for (let i = 0; i < 4; i++) {
//     ctx.beginPath();
//     ctx.moveTo(Math.random() * 120, Math.random() * 40);
//     ctx.lineTo(Math.random() * 120, Math.random() * 40);
//     ctx.strokeStyle = "#9ca3af";
//     ctx.stroke();
//   }

//   // noise-dots
//   for (let i = 0; i < 40; i++) {
//     ctx.beginPath();
//     ctx.arc(Math.random() * 120, Math.random() * 40, 1, 0, 2 * Math.PI);
//     ctx.fillStyle = "#64748b";
//     ctx.fill();
//   }
// }

// 3️⃣  Draw once – after the first DOM paint
// useEffect(() => {
//   if (canvasRef.current) drawCaptcha(captcha);
// }, []);                                          // ← mount only

// // 4️⃣  Reload button
// function handleReload() {
//   const next = generateCaptcha();
//   setCaptcha(next);
//   setUserCaptcha("");
//   drawCaptcha(next);                             // paint immediately
// }










const location = useLocation();


  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes arrowSlide {
        0% { transform: translateX(0); }
        50% { transform: translateX(4px); }
        100% { transform: translateX(0); }
      }
    `;
    document.head.appendChild(style);
  }, []);

  const cardRefs = useRef([]);

  useEffect(() => {
    const animate = () => {
      cardRefs.current.forEach((card, index) => {
        if (card) {
          card.style.opacity = "0";
          card.style.transform = "translateY(40px)";
          card.style.transition = "all 0.5s ease-out";

          setTimeout(() => {
            card.style.opacity = "1";
            card.style.transform = "translateY(0)";
            card.style.transition = `all 0.6s ease-out ${index * 0.1}s`;
          }, 300);
        }
      });
    };

    animate();

    const interval = setInterval(() => {
      animate();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const cardVariant = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };
  const [hoveredIndexx, setHoveredIndexx] = useState(null);

  const getTimeStyle = (isHovered) => ({
    padding: "6px 12px",
    border: `1px solid ${isHovered ? "#004BA8" : "#E5E7EB"}`,
    borderRadius: "6px",
    fontSize: "12px",
    color: isHovered ? "#004BA8" : "#111827",
    backgroundColor: isHovered ? "#E6F0FA" : "#fff",
    cursor: "pointer",
    minWidth: "70px",
    textAlign: "center",
    fontWeight: "500",
    transition: "all 0.2s ease",
  });

  const sections = [
    {
      label: "Afternoon",
      times: ["01:00 PM", "01:30 PM", "02:00 PM", "02:30 PM"],
    },
    {
      label: "Evening",
      times: ["05:00 PM", "05:30 PM", "06:00 PM", "06:30 PM"],
    },
    {
      label: "Night",
      times: ["08:00 PM", "08:30 PM", "09:00 PM", "09:30 PM"],
    },
  ];

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownItems = [
    {
      title: "LOGISTICS OPERATIONS",
      items: [
      {
    name: "Gate",
    description: (
      <>
        Helps organizations track and manage
        <br />
        visitors efficiently.
      </>
    ),
    icon: gate,
  },
        // {
        //   icon: dock,
        //   name: "Dock",
        //   description:
        //     "Helps businesses streamline loading, unloading & scheduling.",
        // },
        // {
        //   icon: sign,
        //   name: "Signage",
        //   description:
        //     "Creating, managing & displaying digital content on screens.",
        // },
      ],
    },
    // {
    //   title: "TRACKING SYSTEM",
    //   items: [
    //     {
    //       icon: trans,
    //       name: "Transport",
    //       description:
    //         "Helps users efficiently manage & optimize transportation services.",
    //     },
    //     {
    //       icon: bus,
    //       name: "Vehicle Management",
    //       description:
    //         "Tracks vehicles, optimizes routes, and automates expenses.",
    //     },
    //     {
    //       icon: asset,
    //       name: "Asset",
    //       description:
    //         "Helps businesses track, monitor, and manage assets efficiently.",
    //     },
    //   ],
    // },
    {
      title: "WORKFORCE MANAGEMENT",
      items: [
       {
    name: "MeetQ",
    description: (
      <>
        Book & manage meeting rooms
        <br />
        with real-time tracking.
      </>
    ),
    icon: q,
  },
        // {
        //   icon: tg,
        //   name: "TickGo",
        //   description: "Track tasks, log hours, and update statuses.",
        // },
        // {
        //   icon: n,
        //   name: "Nexus",
        //   description: "Manage attendance, tasks, and productivity.",
        // },
      ],
    },
  ];

  const [position, setPosition] = useState({
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
  });

  useEffect(() => {
    const randomizePosition = () => {
      setPosition({
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
      });
    };

    const interval = setInterval(randomizePosition, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes float {
        0%   { transform: translateY(0); }
        50%  { transform: translateY(-15px); }
        100% { transform: translateY(0); }
      }
    `;
    document.head.appendChild(style);
  }, []);

  const images = [img1, img2, img3];

  const sizes = [
    { width: 67, height: 200 },
    { width: 96, height: 324 },
    { width: 179, height: 416 },
  ];

  const translateYs = ["-50px", "0", "50px"];

  const [hoveredd, setHoveredd] = useState(null);

  const getSlotStyle = (isHovered) => ({
    padding: "6px 12px",
    border: `1px solid ${isHovered ? "#004BA8" : "#E5E7EB"}`,
    borderRadius: "6px",
    fontSize: "12px",
    color: isHovered ? "#004BA8" : "#111827",
    backgroundColor: isHovered ? "#E6F0FA" : "#fff",
    cursor: "pointer",
    minWidth: "70px",
    textAlign: "center",
    fontWeight: "500",
    transition: "all 0.2s ease",
  });

  const timeSlotsTopRow = [
    "06:00 AM",
    "06:30 AM",
    "07:00 AM",
    "08:00 AM",
    "07:30 AM",
  ];
  const timeSlotsBottomRow = ["09:30 AM", "10:00 AM"];

  const handleClick = (item) => {
    setActiveItem(item);

    if (item === "Products") {
      setShowDropdown(!showDropdown);
    } else {
      setShowDropdown(false);
    }

    if (item === "Home") {
      navigate("/");
    }

    if (item === "Say Hello") {
      navigate("/contact");
    }

    if (item === "Partner") {
      navigate("/part");
    }
  };
  const policyRoutes = {
    "Terms and Conditions": "/terms",
    "Privacy Policy": "/privacy",
    "Cookie Policy": "/cookies",
    "Copyright Policy": "/copyright",
  };





  const products = [
    {
    name: "Gate",
    description: (
      <>
        Helps organizations track and manage
        <br />
        visitors efficiently.
      </>
    ),
    icon: gate,
  },
    // {
    //   name: "Transport",
    //   description:
    //     "Helps users manage and optimize transportation services efficiently.",
    //   icon: trans,
    // },
   {
    name: "MeetQ",
    description: (
      <>
        Book & manage meeting rooms
        <br />
        with real-time tracking.
      </>
    ),
    icon: q,
  },
    // {
    //   name: "Dock",
    //   description: "Helps businesses streamline loading, unloading & scheduling.",
    //   icon: dock,
    // },
    // {
    //   name: "Vehicle Management",
    //   description:
    //     "Tracks vehicles, optimizes routes, and automates expenses.",
    //   icon: bus,
    // },
    // {
    //   name: "TickGo",
    //   description:
    //     "Track tasks, log hours, and update statuses.",
    //   icon: tg,
    // },
    // {
    //   name: "Signage",
    //   description: "Creating, managing & displaying digital content on screens.",
    //   icon: sign,
    // },
    // {
    //   name: "Asset",
    //   description:
    //     "Helps businesses track, monitor, and manage assets efficiently.",
    //   icon: asset,
    // },
    // {
    //   name: "Nexus",
    //   description:
    //     "Manage attendance, tasks, and productivity.",
    //   icon: n,
    // },
   
  ];









  
  const features = [
    {
      title: "Meeting Market Demand",
      description:
        "Demand for manufacturing, warehousing, and logistics may rise in a region / industry.",
      image: one,
    },
    {
      title: "Streamlining Operations",
      description:
        "Companies set up in-house manufacturing, warehousing, and logistics to reduce costs.",
      image: two,
    },
    {
      title: "Control Over Supply Chain",
      description:
        "Owning facilities ensures supply chain control and standards.",
      image: three,
    },
    {
      title: "Competitive Advantage",
      description:
        "A strong manufacturing, warehouse, and logistics setup boosts market advantage.",
      image: four,
    },
    {
      title: "Vertical Integration",
      description:
        "In-house manufacturing, warehousing, and logistics enable vertical integration.",
      image: five,
    },
    {
      title: "Tailored Flexibility",
      description:
        "Owning facilities enables quick adaptation to market trends.",
      image: six,
    },
  ];


  
  const featureData = [
    {
      icon: r1,
      title: "Customization",
      text: "Flexibility and adaptability in a dynamic environment",
    },
    {
      icon: r2,
      title: "End-to-End Solution",
      text: "Flexibility and adaptability in a dynamic environment",
    },
    {
      icon: r3,
      title: "Real-Time Visibility",
      text: "Flexibility and adaptability in a dynamic environment",
    },
    {
      icon: r4,
      title: "Scalability",
      text: "Flexibility and adaptability in a dynamic environment",
    },
  ];
  const feedbacks = [
    {
      logo: fly,
      company: "Flyjac Logistics",
      industry: "Logistics",
      rating: 1,
      feedback:
        "Mawalog delivers exceptional service with precision and efficiency. Their expertise, professionalism, and timely delivery have greatly benefited our business. Highly recommended!",
    },
    {
      logo: w,
      company: "TechWave Solutions",
      industry: "Technology",
      rating: 1,
      feedback:
        "Mawalog transformed our IT infrastructure with their innovative approach and unwavering support. Their team is knowledgeable and always goes the extra mile.",
    },
    {
      logo: t,
      company: "GreenLeaf Organics",
      industry: "Agriculture",
      rating: 1,
      feedback:
        "Working with GreenLeaf has been a game changer for us. Their commitment to sustainability and quality is unmatched, and our yields have significantly improved!",
    },
    {
      logo: c,
      company: "Culinary Creations",
      industry: "Food & Beverage",
      rating: 1,
      feedback:
        "Culinary Creations provides the freshest ingredients and unique flavors that elevate our menu. Their dedication to quality is evident in every bite!",
    },
  ];
  const customers = [
    { logo: c1, name: "Logo 1" },
    { logo: c2, name: "Logo 2" },
    { logo: c3, name: "Logo 3" },
    { logo: c4, name: "Logo 4" },
    { logo: c5, name: "Logo 5" },
    { logo: c6, name: "Logo 6" },
  ];
  const customers1 = [
    { logo: c7, name: "Logo 7" },
    { logo: c8, name: "Logo 8" },
    { logo: c9, name: "Logo 9" },
    { logo: c10, name: "Logo 10" },
    { logo: c11, name: "Logo 11" },
  ];
  const complianceData = [
    { icon: o1, title: "General Data Protection" },
    { icon: o2, title: "SOC2 Compliance Report" },
    { icon: o3, title: "Data Processing Agreement" },
    { icon: o4, title: "ISO Certification" },
    { icon: o5, title: "VAPT Compliance" },
  ];


  


  const items = [
    {
      label: "Customized solutions",
      image: large, 
    },
    {
      label: "Integrated approach",
      image: large1,
    },
    {
      label: "Concept to deliver",
      image: large2, 
    },
  ];







  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.2 }
    );

    if (textRef.current) observer.observe(textRef.current);

    return () => {
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);



  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );
  
    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
  
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);



  
  


  const [inView, setInView] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("slide-in-section");
      if (!section) return;
  
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
  
      
      if (rect.top < windowHeight && rect.bottom > 0) {
        setInView(true);
      } else {
        setInView(false);
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    handleScroll(); 
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const slideInLeft = {
    animation: inView ? "slideInLeft 0.8s ease-out forwards" : "",
  };

  const slideInCenter = {
    animation: inView ? "slideInCenter 0.8s ease-out forwards" : "",
  };

  const slideInRight = {
    animation: inView ? "slideInRight 0.8s ease-out forwards" : "",
  };



  const [inVieww, setInVieww] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    const section = document.getElementById("blog-section");
    if (!section) return;

    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {
      setInVieww(true);
    } else {
      setInVieww(false);
    }
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll();
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

const getSlideInStyle = (delay) =>
  inVieww
    ? {
        animation: `slideInUp 0.6s ease-out ${delay}s both`,
      }
    : { opacity: 0 };






    



    const sectionRef = useRef(null); // Ref for the section element
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // When the section comes into view
        if (entry.isIntersecting) {
          setIsVisible(true); // Set to true when visible
        } else {
          setIsVisible(false); // Reset visibility when not visible
        }
      },
      {
        threshold: 0.5, // Trigger when 50% of the section is in view
      }
    );

    // Observe the sectionRef element
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Clean up the observer on component unmount
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);



  const [hoveredIndex, setHoveredIndex] = useState(0);
  const [currentImage, setCurrentImage] = useState(items[0]?.image || null);

  
  useEffect(() => {
    const interval = setInterval(() => {
      setHoveredIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % items.length;
        setCurrentImage(items[nextIndex].image);
        return nextIndex;
      });
    }, 1000);

    return () => clearInterval(interval); 
  }, [items]);




  const [size, setSize] = useState(getSize());

  function getSize() {
    const width = window.innerWidth;
    if (width <= 480) return { size: 40, bottom: "8%", right: "6%" }; 
    if (width <= 768) return { size: 45, bottom: "6%", right: "5%" }; 
    return { size: 50, bottom: "5%", right: "4%" }; 
  }

  useEffect(() => {
    const handleResize = () => setSize(getSize());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);






 
  

// const POSTS_ENDPOINT =
//   "https://blog.mawalog.com/wp-json/wp/v2/posts?per_page=3&_embed";

// const categoryStyles = {
//   Technology: { bg: "#E5EDFF", fg: "#2563EB" },
//   Health:      { bg: "#E6F4EA", fg: "#22C55E" },
//   Finance:     { bg: "#E8EAF6", fg: "#6366F1" },
//   /* fallback */
//   default:     { bg: "#F3F4F6", fg: "#374151" },
// };


//   const [posts, setPosts] = useState([]);
//   const [loading, setLoading] = useState(true);
//    useEffect(() => {
//     (async () => {
//       try {
//         const res = await fetch(POSTS_ENDPOINT);
//         if (!res.ok) throw new Error("WP API returned " + res.status);
//         const data = await res.json();
//         const cleaned = data.map((p) => ({
//           id: p.id,
//           link: p.link,
//           title: p.title.rendered,
//           date: new Date(p.date).toLocaleDateString("en-US", {
//             year: "numeric",
//             month: "long",
//             day: "numeric",
//           }),
//           tag:
//             p._embedded?.term?.[0]?.[0]?.name ?? "General",
//           img:
//             p._embedded?.["wp:featuredmedia"]?.[0]?.source_url ??
//             "https://via.placeholder.com/600x400?text=Mawalog",
//         }));
//         setPosts(cleaned);
//       } catch (err) {
//         console.error("Could not load Mawalog posts:", err);
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   if (loading) return null; 


  


const [hoveredCard, setHoveredCard] = useState(null);

  const cardStyle = (isHovered) => ({
    border: isHovered ? "2px dashed #1D4ED8" : "2px dashed #E5E5E5",
    borderRadius: "12px",
    padding: "12px",
    backgroundColor: isHovered ? "#F5FAFF" : "#fff",
    display: "inline-block",
    whiteSpace: "nowrap",
    transition: "all 0.3s ease",
    cursor: "pointer",
  });

  const titleStyle = {
    fontSize: "14px",
    color: "#000",
    fontWeight: "600",
    fontFamily: "Epilogue",
    whiteSpace: "nowrap",
  };

  const descStyle = {
    fontSize: "12px",
    color: "#6B7280",
  };


  

    
 const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

   const canvasRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState(""); // text from API
    const [userCaptcha, setUserCaptcha] = useState("");
  
    /* ------------------------------------------------------------------- API fetch */
    const fetchCaptcha = async () => {
      try {
        const res = await fetch(
          "https://api-uat.mawalog.com/admin/v2/api/website"
        );
        const json = await res.json();
        setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
      } catch (err) {
        console.error("Error fetching captcha:", err);
      }
    };
  
    /* -- fetch once on mount ------------------------------------------------------- */
    useEffect(() => {
      fetchCaptcha();
    }, []);
  
    /* -- redraw every time captchaValue changes ------------------------------------ */
    useEffect(() => {
      if (!data) return; // nothing to paint yet
      const canvas = canvasRef.current;
      if (!canvas) return;
  
      const ctx = canvas.getContext("2d");
      const W = canvas.width;
      const H = canvas.height;
  
      /* ========= clear & background */
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, W, H);
  
      /* ========= random faint bezier curves (extra distortion) */
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * W, Math.random() * H);
        ctx.bezierCurveTo(
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H
        );
        ctx.lineWidth = 1 + Math.random(); // 1-2 px
        ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
        ctx.stroke();
      }
  
      /* ========= characters (uneven) */
      ctx.font = "bold 22px Arial";
      ctx.fillStyle = "#0A3A72";
      const chars = data.toString().split("");
  
      chars.forEach((ch, i) => {
        const angle = (Math.random() - 0.5) * 0.8; // ±23°
        const x = 8 + i * 14 + (Math.random() * 4 - 2);
        const y = 22 + (Math.random() * 6 - 3);
  
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillText(ch, 0, 0);
        ctx.restore();
      });
  
      /* ========= dots */
      for (let i = 0; i < 45; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
        ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
        ctx.fill();
      }
    }, [data]);
  
    /* -- reload button click ------------------------------------------------------- */
    const handleReload = () => {
      fetch("https://api-uat.mawalog.com/admin/v2/api/website")
        .then((response) => response.json())
        .then((json) => {
          setData(json.data.captcha_code);
          setSessionid(json.data.session_id);
          setToken(json.data.token);
        })
        .catch((error) => console.error("Error fetching data:", error));
    };
  
  const handleSubscribe = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );

      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
     setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };




  
    const isMobile = screenWidth <= 768;
    const isTablet = screenWidth > 768 && screenWidth <= 1024;
      const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
      const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  
  
       const [isMobileOrTablett, setIsMobileOrTablett] = useState(
      typeof window !== "undefined" ? window.innerWidth <= 1024 : false
    );
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobileOrTablett(window.innerWidth <= 1024);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
  
     const [isMobileOrTablet, setIsMobileOrTablet] = useState(
        typeof window !== "undefined" ? window.innerWidth <= 1024 : false
      );
    
      useEffect(() => {
        const handleResize = () => {
          setIsMobileOrTablett(window.innerWidth <= 1024);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);



       const [posts, setPosts] = useState([]);

  /* ───────────────────────────── fetch & parse ───────────────────────────── */
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        // Fetch HTML through a CORS-friendly proxy
        const raw = await fetch(
          `https://api.allorigins.win/raw?url=${encodeURIComponent(
            "https://blog.mawalog.com/"
          )}`
        ).then((r) => r.text());

        const doc = new DOMParser().parseFromString(raw, "text/html");
        const articles = Array.from(doc.querySelectorAll("article")).slice(0, 3);

        const latest = articles.map((art) => {
          /* image ----------------------------------------------------------- */
          const img = art.querySelector("img")?.src || "";

          /* title & link ----------------------------------------------------- */
          const titleEl = art.querySelector("h1, h2, h3, h4, h5, h6");
          const title = titleEl?.textContent.trim() || "Untitled";
          const href = titleEl?.closest("a")?.href || "#";

          /* category --------------------------------------------------------- */
          const category =
            art.querySelector(".cat-links a, .post-category a, .category a")
              ?.textContent.trim() || "General";

          /* posted date ------------------------------------------------------ */
          const timeEl = art.querySelector("time");
          let date = "Unknown date";

          if (timeEl) {
            const attr = timeEl.getAttribute("datetime");
            if (attr) {
              // Parse the machine date → "May 12, 2025"
              const d = new Date(attr);
              if (!isNaN(d))
                date = d.toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                });
            } else if (timeEl.textContent) {
              // Fallback to visible text inside <time>
              date = timeEl.textContent.trim();
            }
          }

          return { img, title, href, category, date };
        });

        setPosts(latest);
      } catch (err) {
        console.error("Blog fetch failed:", err);
        setPosts([]);
      }
    };

    fetchPosts();                               // first load
    const id = setInterval(fetchPosts, 60 * 60 * 1000); // hourly refresh
    return () => clearInterval(id);             // cleanup
  }, []);



  


  return (
    <div>
{/* <motion.div
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  exit={{ opacity: 0 }}
  transition={{
    duration: 1,
    ease: [0.39, 0.575, 0.565, 1],
  }}
> */}
   
       <ToastContainer
  position="bottom-right"
  autoClose={3000}
  style={{ bottom: "80px" }}
/>

 {/* <div className="fixed-btn">
      <button>
        <img src={icon} alt="button icon" />
      </button>
    </div> */}

<>
        <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    top: 0,
    zIndex: 1000,
    display: "flex",
    position: "sticky",
    justifyContent: "space-between",
    alignItems: "center",
    padding: isMobile ? "10px 3%" : "0px 5%",
    backgroundColor: "#fff",
    flexWrap: "wrap",
     borderBottom: "1px solid #ddd",
  }}
>

<div
  onClick={() => {
    if (window.location.pathname === "/") {
      window.location.reload();
    } else {
      window.location.href = "/";
    }
  }}
  style={{ cursor: "pointer" }}
>
  <img
    src={logo}
    alt="Logo"
    style={{
      maxWidth: isMobile ? "120px" : "150px",
      height: "auto",
      marginLeft: isMobile ? "-10px" : "-50px",
    }}
  />
</div>

   
           {/* Mobile Hamburger Icon */}
           {isMobile && (
             <button
               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
               style={{ background: "none", border: "none", cursor: "pointer" }}
             >
               <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
               </svg>
             </button>
           )}
   
           {/* Desktop/Tablet Menu */}
           {!isMobile && (
             <div
               style={{
                 display: "flex",
                 alignItems: "center",
                 gap: "8px",
                 flexDirection: "row",
                 width: "auto",
                 backgroundColor: "transparent",
                 padding: "0",
               }}
             >
{["Products", "Partner", "Say Hello"].map((item, index) => (
        <div
          key={index}
          style={{ position: "relative", width: "auto" }}
          onMouseEnter={() => {
            setHoveredItem(item);
            if (item === "Products") setShowDropdown(true);
          }}
          onMouseLeave={() => {
            setHoveredItem(null);
            if (item === "Products") setShowDropdown(false);
          }}
        >
          <div
            onClick={() => handleClick(item)}
            style={{
              fontSize: "clamp(12px, 2vw, 16px)",
              cursor: "pointer",
              fontWeight: "normal",
              backgroundColor:
                activeItem === item || hoveredItem === item
                  ? "#EAF3FF"
                  : "transparent",
              padding: "8px 16px",
              borderRadius: "20px",
              transition: "background-color 0.3s",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              justifyContent: "flex-start",
            }}
          >
            {item}
            {item === "Products" && (
              <img
                src={down}
                alt="Down Arrow"
                style={{
                  width: "10px",
                  height: "7px",
                  transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s",
                }}
              />
            )}
          </div>

          {item === "Products" && showDropdown && (
            <div
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
              style={{
                position: "fixed",
                top: 30,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 9999,
                marginTop: "20px",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "24px",
                overflow: "hidden",
                width: "min(980px, 90vw)",
                maxWidth: "100%",
                padding: "16px",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "16px",
                boxSizing: "border-box",
              }}
            >
              {dropdownItems.map((section, i) => (
                <div
                  key={i}
                  style={{
                    paddingRight:
                      i < dropdownItems.length - 1 ? "16px" : undefined,
                    borderRight:
                      i < dropdownItems.length - 1
                        ? "1px solid #E0E0E0"
                        : "none",
                  }}
                >
                  <div
                    style={{
                      color: "#666",
                      fontWeight: 600,
                      marginBottom: 12,
                      textTransform: "uppercase",
                      fontSize: 12,
                    }}
                  >
                    {section.title}
                  </div>

                  {section.items.map((product, j) => (
                    <div
                      key={j}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 10,
                        padding: "8px",
                        cursor: "pointer",
                        marginBottom: 8,
                        borderRadius: 8,
                        transition: "background-color 0.3s ease",
                      }}
                      onClick={() => {
                        if (product.name === "Gate") navigate("/gate");
                        else if (product.name === "MeetQ") navigate("/meetq");
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#F0F8FF";
                        const name = e.currentTarget.querySelector(
                          ".product-name"
                        );
                        const arrow = e.currentTarget.querySelector(".arrow-icon");
                        if (name) name.style.color = "#004aad";
                        if (arrow) {
                          arrow.style.filter =
                            "brightness(0) saturate(100%) invert(17%) sepia(99%) saturate(746%) hue-rotate(197deg) brightness(94%) contrast(100%)";
                          arrow.style.transform = "translateX(4px)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        const name = e.currentTarget.querySelector(
                          ".product-name"
                        );
                        const arrow = e.currentTarget.querySelector(".arrow-icon");
                        if (name) name.style.color = "inherit";
                        if (arrow) {
                          arrow.style.filter = "none";
                          arrow.style.transform = "translateX(0)";
                        }
                      }}
                    >
                      <img
                        src={product.icon}
                        alt={product.name}
                        style={{ width: 20, height: 20 }}
                      />
                      <div>
                        <div
                          className="product-name"
                          style={{
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            transition: "color 0.3s ease",
                            fontSize: 13,
                          }}
                        >
                          {product.name}
                          <img
                            className="arrow-icon"
                            src={nr}
                            alt="arrow"
                            style={{
                              marginLeft: 4,
                              width: 16,
                              height: 16,
                              transition: "filter 0.3s ease, transform 0.3s ease",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            color: "#666",
                            fontSize: 12,
                            textAlign: "left",
                            lineHeight: 1.4,
                          }}
                        >
                          {product.description}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

   
               <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
                 <button
  onClick={() => window.open("http://app.mawalog.com/login", "_blank")}
  className="login-button"
  style={{
    padding: "10px 20px",
    borderRadius: "20px",
    border: "1px solid #004aad",
    backgroundColor: "#fff",
    color: "#004aad",
    fontWeight: "bold",
    cursor: "pointer",
    fontSize: "16px",
    transition: "background-color 0.3s",
  }}
  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
>
  Login
</button>

                 <button
                   onClick={() => window.open("https://app.mawalog.com/register", "_blank")}
                   className="register-button"
                   style={{
                     padding: "10px 20px",
                     borderRadius: "20px",
                     border: "none",
                     backgroundColor: "#004aad",
                     color: "#fff",
                     fontWeight: "bold",
                     cursor: "pointer",
                     fontSize: "16px",
                     transition: "background-color 0.3s",
                   }}
                   onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                   onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                 >
                   Register
                 </button>
               </div>
             </div>
           )}
         </div>
   
         {/* Mobile Menu */}
         {isMobile && isMobileMenuOpen && (
           <div
             style={{
               position: "fixed",
               top: 0,
               left: 0,
               width: "100%",
               height: "100%",
               backgroundColor: "#fff",
               padding: "20px",
               overflowY: "auto",
               zIndex: 1001,
               boxSizing: "border-box",
               fontFamily: "Epilogue, sans-serif",
             }}
           >
             {/* Header with Logo and Close Button */}
             <div
               style={{
                 display: "flex",
                 justifyContent: "space-between",
                 alignItems: "center",
                 marginBottom: "20px",
               }}
             >
               <Link to="/">
  <img
    src={logo}
    alt="Logo"
    style={{ width: "120px", height: "auto", cursor: "pointer" }}
  />
</Link>
               <button
                 onClick={() => setIsMobileMenuOpen(false)}
                 style={{ background: "none", border: "none", cursor: "pointer" }}
               >
                 <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                 </svg>
               </button>
             </div>
   
             {/* Navigation Items */}
             {["Products", "Partner", "Say Hello"].map((item, index) => (
               <div key={index} style={{ marginBottom: "12px", width: "100%" }}>
                 {item === "Products" ? (
                   <>
                     <div
                       onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                       style={{
                         fontSize: "16px",
                         cursor: "pointer",
                         fontWeight: "600",
                         color: "#004aad",
                         padding: "12px",
                         display: "flex",
                         justifyContent: "center",
                         alignItems: "center",
                         borderRadius: "8px",
                         transition: "background-color 0.3s",
                         textAlign: "center",
                       }}
                       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                     >
                       Products
                       <img
                         src={down}
                         alt="Arrow"
                         style={{
                           width: "10px",
                           height: "7px",
                           transform: mobileProductsOpen ? "rotate(180deg)" : "rotate(0deg)",
                           transition: "transform 0.3s",
                         }}
                       />
                     </div>
                     {mobileProductsOpen && (
                       <div
                         style={{
                           marginTop: "12px",
                           padding: "16px",
                           backgroundColor: "#F9FAFB",
                           borderRadius: "12px",
                           display: "flex",
                           flexDirection: "column",
                           gap: "16px",
                           maxWidth: "100%",
                           overflow: "auto",
                           boxSizing: "border-box",
                           justifyContent: "center",
                           alignItems: "center",
                           textAlign: "center",
                         }}
                       >
                         {dropdownItems.map((section, i) => (
                           <div key={i} style={{ marginBottom: "16px", width: "100%", maxWidth: "90%" }}>
                             <div
                               style={{
                                 color: "#666",
                                 fontWeight: "600",
                                 textTransform: "uppercase",
                                 fontSize: "12px",
                                 marginBottom: "8px",
                               }}
                             >
                               {section.title}
                             </div>
                             {section.items.map((product, j) => (
                               <div
                                 key={j}
                                 style={{
                                   display: "flex",
                                   flexDirection: "column",
                                   alignItems: "center",
                                   gap: "8px",
                                   padding: "8px",
                                   cursor: "pointer",
                                   borderRadius: "8px",
                                   transition: "background-color 0.3s ease",
                                   maxWidth: "100%",
                                 }}
                                 onClick={() => {
                                   if (product.name === "Gate") navigate("/gate");
                                   else if (product.name === "MeetQ") navigate("/meetq");
                                   setIsMobileMenuOpen(false);
                                 }}
                                 onMouseEnter={(e) => {
                                   e.currentTarget.style.backgroundColor = "#F0F8FF";
                                   const name = e.currentTarget.querySelector(".product-name");
                                   name.style.color = "#004aad";
                                 }}
                                 onMouseLeave={(e) => {
                                   e.currentTarget.style.backgroundColor = "transparent";
                                   const name = e.currentTarget.querySelector(".product-name");
                                   name.style.color = "inherit";
                                 }}
                               >
                                 <img src={product.icon} alt={product.name} style={{ width: "20px", height: "20px" }} />
                                 <div style={{ flex: 1, overflow: "hidden" }}>
                                   <div
                                     className="product-name"
                                     style={{
                                       fontWeight: "600",
                                       fontSize: "14px",
                                       transition: "color 0.3s ease",
                                       whiteSpace: "normal",
                                       overflow: "hidden",
                                       textOverflow: "ellipsis",
                                       textAlign: "center",
                                     }}
                                   >
                                     {product.name}
                                   </div>
                                   <div
                                     style={{
                                       color: "#666",
                                       fontSize: "12px",
                                       lineHeight: "1.4",
                                       overflowWrap: "break-word",
                                       textAlign: "center",
                                     }}
                                   >
                                     {product.description}
                                   </div>
                                 </div>
                               </div>
                             ))}
                           </div>
                         ))}
                         <a
                           href="#"
                           style={{
                             color: "#004aad",
                             fontWeight: "600",
                             fontSize: "14px",
                             textDecoration: "none",
                             display: "inline-flex",
                             alignItems: "center",
                             padding: "8px",
                           }}
                           onClick={() => setIsMobileMenuOpen(false)}
                         >
                           Explore all products
                           <img
                             src={right}
                             alt="arrow"
                             style={{
                               marginLeft: "4px",
                               width: "16px",
                               height: "16px",
                               verticalAlign: "middle",
                             }}
                           />
                         </a>
                       </div>
                     )}
                   </>
                 ) : (
                   <div
                     onClick={() => {
                       handleClick(item);
                       setIsMobileMenuOpen(false);
                     }}
                     style={{
                       fontSize: "16px",
                       cursor: "pointer",
                       fontWeight: "600",
                       color: "#004aad",
                       padding: "12px",
                       borderRadius: "8px",
                       transition: "background-color 0.3s",
                       textAlign: "center",
                     }}
                     onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                     onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                   >
                     {item}
                   </div>
                 )}
               </div>
             ))}
   
             {/* Buttons */}
             <div
               style={{
                 display: "flex",
                 flexDirection: "column",
                 gap: "12px",
                 width: "100%",
                 marginTop: "20px",
               }}
             >
               <button
                 onClick={() => {
                   window.location.href = "http://app.mawalog.com/login";
                   setIsMobileMenuOpen(false);
                 }}
                 style={{
                   padding: "8px 16px",
                   borderRadius: "20px",
                   border: "1px solid #004aad",
                   backgroundColor: "#fff",
                   color: "#004aad",
                   fontWeight: "bold",
                   cursor: "pointer",
                   fontSize: "14px",
                   width: "100%",
                   transition: "background-color 0.3s",
                 }}
                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
               >
                 Login
               </button>
               <button
                 onClick={() => {
                   window.open("https://app.mawalog.com/register", "_blank");
                   setIsMobileMenuOpen(false);
                 }}
                 style={{
                   padding: "8px 16px",
                   borderRadius: "20px",
                   border: "none",
                   backgroundColor: "#004aad",
                   color: "#fff",
                   fontWeight: "bold",
                   cursor: "pointer",
                   fontSize: "14px",
                   width: "100%",
                   transition: "background-color 0.3s",
                 }}
                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
               >
                 Register
               </button>
             </div>
           </div>
         )}
   
         {/* Media Queries for Tablet Button Size */}
         <style>
           {`
             @media (min-width: 769px) and (max-width: 1024px) {
               .login-button, .register-button {
                 padding: 8px 16px !important;
                 font-size: 14px !important;
               }
             }
           `}
         </style>
       </>

<div
  style={{
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    fontFamily: "Epilogue",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "3rem 2rem 0rem",  // top, left/right, bottom
    background: "#F0F7FF",
    position: "relative",
  }}
>

  {/* Left Content */}
  <div
    style={{
      maxWidth: "480px",
      flex: "1 1 320px",
      marginLeft: "30px",
      paddingTop: "1.25rem",
    }}
  >
    <p
      style={{
        textTransform: "uppercase",
        fontSize: "0.75rem",
        letterSpacing: "0.1em",
        fontWeight: 600,
        color: "#0052cc",
        margin: 0,
        marginBottom: "1rem",
      }}
    >
      Platform for your industries
    </p>

    <h1
      style={{
        fontSize: "38px",
        lineHeight: 1.2,
        fontWeight: 700,
        color: "#0d1d3d",
        margin: 0,
        marginBottom: "1.5rem",
      }}
    >
      Mawalog powers
      <br />
      precision in every move.
    </h1>

    <p
      style={{
        fontSize: "10px",
        lineHeight: 1.6,
        color: "#354052",
        margin: 0,
        marginBottom: "2rem",
      }}
    >
      We are committed to delivering expert IT consulting and premium services with the highest standards of professionalism.
    </p>

    <div
      style={{
        display: "flex",
        gap: "1rem",
        flexWrap: "wrap",
        justifyContent: "left",
        alignItems: "center",
      }}
    >
      <button
        onClick={toggleSlider}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`book-demo-btn ${isHovered ? "hovered" : ""}`}
      >
        Book a demo
        <div className={`arrow-container ${isHovered ? "arrow-animate" : ""}`}>
          <img
            src={Ar}
            alt="Arrow Icon"
            className="arrow-icon"
            style={{ marginTop: "4px" }}
          />
        </div>
      </button>

      <button
        className="get-in-touch-btn"
        onClick={() => navigate("/contact#contact-form-section")}
      >
        Get in touch
      </button>
    </div>

    {/* Tinted overlay */}
    {isOpen && (
      <div className="overlay" onClick={toggleSlider}></div>
    )}

    {/* Sliding panel */}
    <div className={`sliding-panel ${isOpen ? "open" : ""}`}>
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <div style={{ textAlign: "right", padding: "10px 0" }}>
          <button
            onClick={toggleSlider}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              zIndex: 2,
            }}
          >
            ❌
          </button>
        </div>
        <iframe
          src="https://outlook.office365.com/book/MawalogOne@lenteratechno.onmicrosoft.com/"
          title="Book a Demo"
          style={{
            flex: 1,
            width: "100%",
            border: "none",
          }}
        ></iframe>
      </div>
    </div>
  </div>

  {/* Right Visual Section */}
  <section
    className="hero-visual"
    style={{
      position: "relative",
      flex: "1 1 400px",
      maxWidth: "500px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingBottom: "0",
    }}
  >
    <img src={person} alt="Smiling man with laptop" style={{ width: 200, zIndex: 1 }} />
    <img src={bi} alt="Business digitalization card" style={{ ...imgStyle, width: 250, top: 100, left: -80, animation: "floatY 3.5s ease-in-out infinite" }} />
    <img src={mai} alt="mai chat widget" style={{ ...imgStyle, width: 200, top: 80, right: -20, animation: "floatY 3.5s ease-in-out infinite 1.2s" }} />
    <img src={g} alt="" style={{ ...imgStyle, width: 22, top: 80, left: 170, animation: "spin 8s linear infinite" }} />
    <img src={b8} alt="" style={{ ...imgStyle, width: 22, top: 50, left: 180, animation: "spin 11s linear infinite reverse" }} />
    <img src={y} alt="" style={{ ...imgStyle, width: 22, top: 60, left: 140, animation: "spin 16s linear infinite" }} />
    <img src={s} alt="" style={{ ...imgStyle, width: 30, top: 50, right: 180, animation: "blink 1.4s ease-in-out infinite" }} />
    <div
      style={{
        marginBottom: "5rem",
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
        zIndex: 2,
      }}
    >
      <img src={manufacturing} alt="Manufacturing" style={{ width: 130 }} />
      <img src={warehouse} alt="Warehouse management" style={{ width: 130 }} />
      <img src={log} alt="Logistics" style={{ width: 130 }} />
    </div>
  </section>

  <style>{`
    .book-demo-btn {
      padding: 0.6rem 1.2rem;
      font-size: 1rem;
      font-weight: 600;
      border-radius: 6px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #0052cc;
      background-color: #0052cc;
      color: white;
      transition: background-color 0.3s, color 0.3s;
    }

    .book-demo-btn.hovered,
    .book-demo-btn:hover {
      background-color: #003d99;
      color: white;
    }

    .get-in-touch-btn {
      padding: 0.6rem 1.2rem;
      font-size: 1rem;
      font-weight: 600;
      border-radius: 6px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #0052cc;
      background: transparent;
      color: #0052cc;
      transition: background-color 0.3s, color 0.3s;
    }

    .get-in-touch-btn:hover {
      background-color: #0052cc;
      color: white;
    }

    .arrow-container {
      display: inline-block;
      margin-left: 8px;
      transition: transform 0.3s;
    }

    .arrow-icon {
      width: 12px;
      height: 12px;
      transition: transform 0.3s;
    }

    .arrow-animate .arrow-icon {
      transform: translateX(5px);
    }

    .sliding-panel {
      position: fixed;
      top: 0;
      right: 0;
      height: 100%;
      width: 50%;
      max-width: 600px;
      background-color: #fff;
      transform: translateX(100%);
      transition: transform 0.4s ease-in-out;
      z-index: 1000;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      box-sizing: border-box;
      box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    }

    .sliding-panel.open {
      transform: translateX(0);
    }

    .overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.5);
      z-index: 999;
      transition: opacity 0.3s ease-in-out;
    }

    @media (max-width: 1200px) {
      .sliding-panel {
        width: 60%;
      }
    }

    @media (max-width: 991px) {
      .sliding-panel {
        width: 80%;
      }

      .book-demo-btn,
      .get-in-touch-btn {
        padding: 0.5rem 1rem;
        font-size: 0.9rem;
      }
    }

    @media (max-width: 768px) {
      .sliding-panel {
        width: 90%;
        border-radius: 12px 0 0 12px;
        box-shadow: -4px 0 12px rgba(0, 0, 0, 0.15);
      }

      .book-demo-btn,
      .get-in-touch-btn {
        width: 100%;
        justify-content: center;
      }

      .arrow-container {
        display: none;
      }

      .hero-visual {
        display: none !important;
        height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
      }
    }

    @media (max-width: 576px) {
      .sliding-panel {
        width: 95%;
      }

      .sliding-panel iframe {
        height: 100% !important;
      }
    }
  `}</style>
</div>












   <>
  <style>{`
    @keyframes slideInLeft {
      from {
        opacity: 0;
        transform: translateX(-50px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .slide-in-left {
      animation: slideInLeft 0.5s ease-out forwards;
      will-change: transform, opacity;
    }

    /* Responsive font sizes for title */
    @media (max-width: 1200px) {
      div[style*="fontSize: clamp(20px, 2.5vw, 30px)"] {
        font-size: clamp(18px, 3vw, 28px);
        margin-bottom: clamp(5px, 1vw, 10px);
        margin-top: 25px;
      }
    }

    @media (max-width: 768px) {
      div[style*="fontSize: clamp(20px, 2.5vw, 30px)"] {
        font-size: clamp(16px, 4vw, 24px);
        margin-top: 20px;
      }

      p[style*="fontSize: clamp(14px, 1.2vw, 16px)"] {
        font-size: clamp(12px, 3vw, 14px);
        max-width: 90%;
      }

      iframe {
        width: 90% !important;
        height: 35vw !important;
      }
    }

    @media (max-width: 480px) {
      div[style*="fontSize: clamp(20px, 2.5vw, 30px)"] {
        font-size: clamp(14px, 5vw, 20px);
        margin-top: 15px;
      }

      p[style*="fontSize: clamp(14px, 1.2vw, 16px)"] {
        font-size: clamp(10px, 4vw, 12px);
        max-width: 95%;
      }

      iframe {
        width: 95% !important;
        height: 40vw !important;
      }
    }
  `}</style>

  <div ref={sectionRef}>
    {/* Title */}
    <div
      style={{
        fontSize: "clamp(20px, 2.5vw, 30px)",
        fontFamily: "Epilogue",
        color: "#1E1E1E",
        marginBottom: "clamp(6px, 1vw, 12px)",
        textAlign: "center",
        maxWidth: "100%",
        marginTop: "30px",
        wordBreak: "break-word",
      }}
    >
      What we gonna add to your business?
    </div>

    {/* Subtext and Image */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "clamp(6px, 1vw, 12px)",
        textAlign: "center",
        maxWidth: "100%",
        padding: "0 5%",
      }}
    >
      <p
        style={{
          fontFamily: "Epilogue",
          fontSize: "clamp(14px, 1.2vw, 16px)",
          color: "#6B7280",
          marginBottom: "0",
          maxWidth: "600px",
        }}
      >
        We add different types of values to you from our applications seamlessly
      </p>

      <iframe
        src="https://www.youtube.com/embed/LIs_rg6ZPRA?autoplay=1&mute=1&loop=1&playlist=LIs_rg6ZPRA"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        style={{
          width: "clamp(400px, 90%, 700px)",
          height: "clamp(200px, 40vw, 400px)",
          display: "block",
          margin: "0 auto",
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateX(0)" : "translateX(-50px)",
          transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
        }}
      />
    </div>
  </div>
</>

      <>
  <div
    style={{
      padding: "0 5%",
      maxWidth: "1200px",
      margin: "0 auto",
      textAlign: "center",
    }}
  >
    <h2
      style={{
        fontSize: "clamp(22px, 3vw, 36px)",
        fontWeight: "bold",
        color: "#000000",
        fontFamily: "Epilogue",
        marginBottom: "12px",
        lineHeight: "1.3",
      }}
    >
      Our products
    </h2>

    <p
      style={{
        color: "#6B7280",
        fontSize: "clamp(14px, 1.6vw, 18px)",
        lineHeight: "1.6",
        maxWidth: "700px",
        fontFamily: "Epilogue",
        margin: "0 auto",
      }}
    >
      For boosting your process seamlessly in an effective way
    </p>
  </div>

  <style>{`
    /* Responsive font adjustments */

    @media (max-width: 1200px) {
      h2 {
        font-size: clamp(20px, 3.5vw, 32px);
        margin-bottom: 10px;
      }
      p {
        font-size: clamp(13px, 1.8vw, 16px);
        max-width: 90%;
      }
    }

    @media (max-width: 768px) {
      h2 {
        font-size: clamp(18px, 4vw, 28px);
        margin-bottom: 8px;
      }
      p {
        font-size: clamp(12px, 3vw, 14px);
        max-width: 95%;
      }
    }

    @media (max-width: 480px) {
      h2 {
        font-size: clamp(16px, 5vw, 24px);
        margin-bottom: 6px;
      }
      p {
        font-size: clamp(11px, 4vw, 13px);
        max-width: 100%;
      }
    }
  `}</style>
</>


  <>
  <motion.div
    variants={container}
    initial="hidden"
    whileInView="show"
    viewport={{ once: false, amount: 0.2 }}
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "24px",
      marginTop: "40px",
      padding: "0 5%",
      maxWidth: "900px",
      width: "100%",
      boxSizing: "border-box",
      marginLeft: "auto",
      marginRight: "auto",
    }}
  >
    {products.slice(0, 9).map((product, index) => (
      <motion.div
        key={index}
        variants={cardVariant}
        whileHover={{
          scale: 1.02,
          transition: { duration: 0.3 },
        }}
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "16px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          cursor: "pointer",
          minWidth: "0",
          transition: "all 0.3s",
          border: "1px solid #E5E5E5",
        }}
        onClick={() => {
          if (product.name === "Gate") {
            navigate("/gate");
          } else if (product.name === "MeetQ") {
            navigate("/meetq");
          }
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.border = "2px solid";
          e.currentTarget.style.borderTopColor = "#004BA8";
          e.currentTarget.style.borderLeftColor = "#004BA8";
          e.currentTarget.style.borderRightColor = "#8380FF";
          e.currentTarget.style.borderBottomColor = "#8380FF";
          e.currentTarget.querySelector("h3").style.color = "#007bff";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.border = "1px solid #E5E5E5";
          e.currentTarget.querySelector("h3").style.color = "#000";
        }}
      >
        <img
          src={product.icon}
          alt={product.name}
          style={{
            width: "30px",
            height: "30px",
            objectFit: "contain",
            flexShrink: 0,
          }}
        />
        <div
          style={{
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h3
            style={{
              fontFamily: "Epilogue",
              margin: "0",
              fontSize: "16px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "#000",
              transition: "color 0.3s",
            }}
          >
            {product.name}
            <img
              src={riarr}
              alt="Arrow"
              style={{ width: "16px", height: "16px" }}
            />
          </h3>
          <p
            style={{
              fontFamily: "Epilogue",
              margin: "8px 0 0",
              color: "#6B7280",
              lineHeight: "1.4",
              fontSize: "14px",
            }}
          >
            {product.description}
          </p>
        </div>
      </motion.div>
    ))}
  </motion.div>

  {/* Button Section */}
{/* <div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "40px",
    padding: "0 5%",
    width: "100%",
    boxSizing: "border-box",
  }}
>
  <Link to="/explore" style={{ textDecoration: "none" }}>
    <button
      style={{
        padding: "12px 24px",
        backgroundColor: "#F8F8F8",
        color: "#004BA8",
        borderRadius: "24px",
        fontWeight: "bold",
        border: "none",
        cursor: "pointer",
        fontSize: "clamp(14px, 1.5vw, 16px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Epilogue",
        gap: "8px",
        whiteSpace: "nowrap",
        maxWidth: "100%",
      }}
    >
      Explore all products
      <img
        src={right}
        alt="Arrow"
        style={{
          width: "clamp(16px, 2vw, 20px)",
          height: "clamp(16px, 2vw, 20px)",
          flexShrink: 0,
        }}
      />
    </button>
  </Link>
</div> */}

  <style>{`
    /* Responsive grid adjustments */
    @media (max-width: 1200px) {
      div[style*="grid-template-columns"] {
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)) !important;
        max-width: 100% !important;
        padding: 0 3% !important;
      }
      h3 {
        font-size: 15px !important;
      }
      p {
        font-size: 13px !important;
      }
      button {
        font-size: 14px !important;
        padding: 10px 20px !important;
      }
    }

    @media (max-width: 768px) {
      div[style*="grid-template-columns"] {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)) !important;
        padding: 0 5% !important;
        margin-top: 32px !important;
      }
      h3 {
        font-size: 14px !important;
      }
      p {
        font-size: 12px !important;
      }
      button {
        font-size: 13px !important;
        padding: 10px 16px !important;
      }
    }

    @media (max-width: 480px) {
      div[style*="grid-template-columns"] {
        grid-template-columns: 1fr !important;
        gap: 16px !important;
        padding: 0 4% !important;
        margin-top: 24px !important;
      }
      h3 {
        font-size: 13px !important;
      }
      p {
        font-size: 11px !important;
      }
      button {
        font-size: 12px !important;
        padding: 8px 14px !important;
      }
    }
  `}</style>
</>


    <div
  style={{
    width: "100%",
    boxSizing: "border-box",
    overflowX: "hidden",
    padding: "clamp(20px, 4vw, 60px) 0",
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
    marginTop: "20px",
    background: "linear-gradient(to bottom, #FFE7BA, #E6E6FA)",
    backgroundImage: `url(${back})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div
    style={{
      fontFamily: "Epilogue",
      lineHeight: "1.4",
      maxWidth: "1100px",
      margin: "0 auto",
      padding: "0 5vw",
      boxSizing: "border-box",
    }}
  >
    <h2
      style={{
        fontSize: "clamp(20px, 3vw, 28px)",
        fontWeight: "bold",
        color: "#000",
      }}
    >
      Key features of our application
    </h2>
    <p
      style={{
        color: "#6B7280",
        marginBottom: "20px",
        fontSize: "clamp(10px, 1.5vw, 14px)",
      }}
    >
      We added some more effective features that make your work much easier.
    </p>

    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "0 5px",
        boxSizing: "border-box",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "clamp(16px, 2vw, 32px)",
          justifyContent: "center",
          alignItems: "stretch",
        }}
      >
        {features.map((feature, index) => (
          <div
            key={index}
            ref={(el) => (cardRefs.current[index] = el)}
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
              cursor: "pointer",
              height: "230px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              opacity: 1,
              transform: "translateY(0)",
              transition: `all 0.6s ease-out`,
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.05)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "scale(1)")
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "120px",
              }}
            >
              <img
                src={feature.image}
                alt={feature.title}
                style={{
                  width: "clamp(150px, 90%, 260px)",
                  height: "clamp(100px, 90vw, 200px)",
                  maxWidth: "100%",
                  maxHeight: "100%",
                  borderRadius: "8px",
                  objectFit: "cover",
                  transition: "all 0.3s ease-in-out",
                  marginTop: "20px",
                  marginBottom: "-3px",
                }}
              />
            </div>

            <div
              style={{
                padding: "clamp(8px, 1vw, 12px)",
                textAlign: "start",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start", // Ensure content starts from the top
                flexGrow: 1,
              }}
            >
              <div
                style={{
                  fontSize: "clamp(14px, 1.5vw, 18px)",
                  fontWeight: "bold",
                  marginTop: "10px", // Remove negative margin
                  marginLeft: "12px",
                  color: "#000",
                }}
              >
                {feature.title}
              </div>
              <div
                style={{
                  color: "#6B7280",
                  textAlign: "left",
                  fontSize: "clamp(11px, 1vw, 13px)",
                  marginTop: "clamp(4px, 1vw, 6px)",
                  marginLeft: "12px",
                  lineHeight: "clamp(1.2, 1.5vw, 1.6)",
                }}
              >
                {feature.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>

  <style>{`
    /* Responsive Grid for Features */
    @media (max-width: 1024px) {
      div[style*="grid-template-columns"] {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: clamp(12px, 2vw, 24px) !important;
      }
    }
    @media (max-width: 640px) {
      div[style*="grid-template-columns"] {
        grid-template-columns: 1fr !important;
        gap: clamp(12px, 4vw, 24px) !important;
      }
    }

    /* Responsive font scaling */
    h2 {
      font-size: clamp(20px, 5vw, 28px) !important;
    }
    p {
      font-size: clamp(12px, 3vw, 14px) !important;
    }
    div[style*="fontSize: clamp(14px, 1.5vw, 18px)"] {
      font-size: clamp(14px, 3vw, 18px) !important;
    }
    div[style*="fontSize: clamp(11px, 1vw, 13px)"] {
      font-size: clamp(11px, 2.5vw, 13px) !important;
    }
  `}</style>
</div>


     <>
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "clamp(20px, 5vw, 60px)",
      background: "#fff",
      textAlign: "left",
      gap: "clamp(20px, 4vw, 40px)",
      boxSizing: "border-box",
    }}
  >
    {/* Left Text Content */}
    <div
      ref={textRef}
      style={{
        fontFamily: "Epilogue",
        lineHeight: "1.4",
        flex: "1 1 400px",
        minWidth: "280px",
        maxWidth: "600px",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateX(0)" : "translateX(-60px)",
        transition: "all 0.8s ease-out",
      }}
    >
      <div
        style={{
          background: "#E0ECFF",
          color: "#007BFF",
          padding: "5px 15px",
          borderRadius: "15px",
          display: "inline-block",
          fontSize: "14px",
          marginBottom: "10px",
        }}
      >
        About us
      </div>
      <h2
        style={{
          fontSize: "clamp(22px, 2.5vw, 32px)",
          fontWeight: "bold",
          color: "#1D1D1D",
          marginTop: "10px",
        }}
      >
        Ready to Simplify your Supply Chain Management?
      </h2>
      <p
        style={{
          fontSize: "clamp(14px, 1.2vw, 18px)",
          color: "#555",
          marginTop: "10px",
          lineHeight: "1.6",
        }}
      >
        At Mawalog, we believe in simplifying the complexities of supply chain
        management and engineering a seamless flow. By offering an integrated
        platform that combines manufacturing, logistics, and warehouse solutions.
      </p>
    </div>

    {/* Right Image Grid */}
    <div
      ref={imageRef}
      className="image-grid"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-end",
        gap: "clamp(16px, 2vw, 32px)",
        padding: "20px",
        maxWidth: "1200px",
        margin: "0 auto",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateX(0)" : "translateX(60px)",
        transition: "all 0.8s ease-out",
      }}
    >
      {images.map((img, index) => {
        const size = sizes[index];
        const translateY = translateYs[index];

        return (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              width: `${size.width}px`,
              height: `${size.height}px`,
              overflow: "hidden",
              transform: `translateY(${translateY})`,
              transition: "transform 0.3s ease",
            }}
          >
            <img
              src={img}
              alt={`Image ${index + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "4px",
                animation: `float 3s ease-in-out infinite`,
                animationDelay: `${index * 0.3}s`,
              }}
            />
          </div>
        );
      })}
    </div>
  </div>

  {/* Responsive Styles */}
  <style>{`
    /* Remove sliding animation on tablets and below */
    @media (max-width: 1024px) {
      div[style*="transform: translateX(0)"], 
      div[style*="transform: translateX(-60px)"], 
      div[style*="transform: translateX(60px)"] {
        transform: none !important;
        transition: none !important;
        opacity: 1 !important;
      }
    }
    
    /* Hide the right image grid completely on mobile (<=640px) */
    @media (max-width: 640px) {
      .image-grid {
        display: none !important;
      }
    }
  `}</style>
</>


      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          padding: "5vw",
          background: "#0A0A24",
          color: "#fff",
          gap: "2vw",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            flex: "1 1 300px",
            display: "flex",
            justifyContent: "center",
            padding: "20px",
            minWidth: "280px",
            maxWidth: "100%",
            boxSizing: "border-box",
          }}
        >
          <img
            src={group}
            alt="Team Discussion"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
              width: "clamp(180px, 35vw, 300px)",
              height: "auto",
              maxWidth: "100%",
              objectFit: "contain",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              transform: hovered
                ? "scale(1.05) rotate3d(1, 1, 0, 5deg)"
                : "scale(1)",
              boxShadow: hovered ? "0 10px 20px rgba(0, 0, 0, 0.1)" : "none",
            }}
          />
        </div>

        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            flex: "2 1 500px",
            minWidth: "320px",
            padding: "20px",
            textAlign: "left",
            maxWidth: "100%",
            boxSizing: "border-box",
          }}
        >
          <h2
            style={{
              fontSize: "clamp(24px, 2.2vw, 32px)",
              fontFamily:"Epilogue",
              color :"#fff",
              fontWeight: "bold",
            }}
          >
            What are we proficient at
          </h2>
          <p
            style={{
              fontSize: "clamp(14px, 1.1vw, 16px)",
              marginTop: "10px",
              color: "#ccc",
            }}
          >
            Our mission is to empower businesses of all sizes to streamline
            their operations and achieve greater success in today’s competitive
            marketplace.
          </p>

          <div
      ref={containerRef}
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        gap: "20px",
        marginTop: "20px",
        width: "100%",
      }}
    >
      {featureData.map((feature, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            padding: "10px",
            position: "relative",
            boxSizing: "border-box",
            opacity: visible ? 1 : 0,
            transform: visible ? "scale(1)" : "scale(0.8)",
            transition: `all 0.6s ease ${index * 0.2}s`,
          }}
        >
          <img
            src={feature.icon}
            alt={feature.title}
            style={{
              width: "clamp(40px, 4.5vw, 60px)",
              height: "clamp(40px, 4.5vw, 60px)",
              marginBottom: "10px",
            }}
          />
          <h3
            style={{
              fontSize: "clamp(10px, 0.9vw, 14px)",
              fontWeight: "bold",
              margin: "5px 0",
            }}
          >
            {feature.title}
          </h3>
          <p
            style={{
              fontSize: "clamp(8px, 0.75vw, 12px)",
              color: "#aaa",
              textAlign: "center",
              lineHeight: "1.4",
              margin: "0",
            }}
          >
            {feature.text}
          </p>

          {index < featureData.length - 1 && (
            <div
              style={{
                position: "absolute",
                right: "-10px",
                top: "20%",
                height: "60%",
                borderLeft: "2px solid rgba(255,255,255,0.3)",
              }}
            ></div>
          )}
        </div>
      ))}
    </div>
        </div>
      </div>

     <>
  <style>{`
    @media (max-width: 480px) {
      /* Stack text and image vertically on small/mobile screens */
      .responsive-container {
        flex-direction: column !important;
        gap: 20px !important;
      }

      /* Make image section take full width */
      .responsive-container img {
        max-width: 100% !important;
        height: auto !important;
        max-height: none !important;
      }

      /* Make text and image sections full width */
      .responsive-container > div {
        flex: 1 1 100% !important;
        min-width: auto !important;
      }
    }
  `}</style>

  <div
    className="responsive-container"
    style={{
      fontFamily: "Epilogue",
      lineHeight: "1.4",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "40px",
      width: "90%",
      maxWidth: "1400px",
      margin: "0 auto",
      padding: "40px 20px",
      flexWrap: "wrap",
      boxSizing: "border-box",
    }}
  >
    {/* Text Section */}
    <div
      style={{
        flex: "1 1 300px",
        minWidth: "300px",
        boxSizing: "border-box",
      }}
    >
      <h1
        style={{
          fontSize: "clamp(22px, 3vw, 36px)",
          fontWeight: "bold",
          color: "#000",
          marginBottom: "20px",
        }}
      >
        How Mawalog stands <br /> out from the crowd?
      </h1>
      <div
        style={{
          borderLeft: "2px solid #E5E7EB",
          paddingLeft: "15px",
        }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              borderRadius: "10px",
              marginBottom: "20px",
            }}
          >
            <span style={{ color: "#004BA8", fontSize: "20px" }}>-</span>
            <p
              style={{
                color: hoveredIndex === index ? "#ffffff" : "#616161",
                fontSize: "14px",
                margin: 0,
                padding: hoveredIndex === index ? "9px 16px" : "4px 8px",
                borderRadius: hoveredIndex === index ? "100px" : "8px",
                backgroundColor:
                  hoveredIndex === index ? "#004BA8" : "transparent",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={() => {
                setHoveredIndex(index);
                setCurrentImage(item.image);
              }}
            >
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </div>

    {/* Image Section */}
    <div
      style={{
        flex: "1.5 1 300px",
        minWidth: "300px",
        boxSizing: "border-box",
      }}
    >
      <img
        src={currentImage || large}
        alt="Hovered visual"
        style={{
          width: "100%",
          height: "auto",
          maxHeight: "350px",
          objectFit: "cover",
          borderRadius: "12px",
          display: "block",
          transition: "0.3s ease",
        }}
      />
    </div>
  </div>
</>


     <>
  <style>{`
    /* Scroll container default: horizontal row */
    #slide-in-section > div:nth-child(3) {
      display: flex !important;
      justify-content: center !important;
      gap: 40px !important;
      flex-wrap: nowrap !important;
      overflow-x: auto !important;
      max-width: 100% !important;
      padding: 20px !important;
      margin-top: -50px !important;
      scrollbar-width: none !important;
      -webkit-overflow-scrolling: touch !important;
    }

    /* Mobile phones: stack cards vertically, full width */
    @media (max-width: 767px) {
      #slide-in-section > div:nth-child(3) {
        flex-direction: column !important;
        overflow-x: visible !important;
        gap: 20px !important;
        margin-top: 0 !important;
        padding: 10px !important;
      }

      #slide-in-section > div:nth-child(3) > div {
        width: 100% !important;
        max-width: 100% !important;
        flex-shrink: 0 !important;
      }
    }

    /* Tablets: keep horizontal scroll with wrap */
    @media (min-width: 768px) and (max-width: 1024px) {
      #slide-in-section > div:nth-child(3) {
        flex-wrap: nowrap !important;
        overflow-x: auto !important;
        gap: 30px !important;
        margin-top: -50px !important;
        padding: 20px !important;
      }
      
      #slide-in-section > div:nth-child(3) > div {
        width: 280px !important;
        flex-shrink: 0 !important;
      }
    }
  `}</style>

  <div
    id="slide-in-section"
    style={{
      fontFamily: "Epilogue",
      lineHeight: "1.4",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      backgroundColor: "#F8FAFC",
      padding: "30px",
      boxSizing: "border-box",
    }}
  >
    <div
      style={{
        fontSize: "36px",
        fontWeight: "bold",
        color: "#000",
        marginBottom: "10px",
      }}
    >
      We've got it all covered
    </div>
    <p
      style={{
        color: "#6B7280",
        fontSize: "16px",
        marginBottom: "50px",
      }}
    >
      We have all what we expect from us
    </p>

   <div
  style={{
    display: "flex",
    justifyContent: "center",
    gap: "40px",
    flexWrap: "nowrap",
    overflowX: "auto",
    maxWidth: "100%",
    padding: "20px",
    marginTop: "-50px",
    scrollbarWidth: "none",
    WebkitOverflowScrolling: "touch",
  }}
>
  {[g1, g2, g3].map((img, index) => {
    const titles = [
      "Precision Engineering",
      "Inventory Optimization",
      "Supply Chain Management",
    ];
    const descriptions = [
      "Mawalog delivers advanced manufacturing solutions with robotics, CNC machines, and automation to maximize productivity and minimize downtime.",
      "Specializes in warehouse management with RFID, barcode, QR scanners, and inventory software to streamline operations and accuracy.",
      "Encompass Logistics' GPS tracking and fleet management software provide real-time visibility, cost savings, and operational excellence in supply chains.",
    ];

    const isMobile = window.innerWidth <= 768; // disable animation on mobile
    const animationStyle = isMobile
      ? {}
      : index === 0
      ? slideInLeft
      : index === 1
      ? slideInCenter
      : slideInRight;

    return (
      <div
        key={index}
        style={{
          backgroundColor: "#F8FAFC",
          padding: "20px",
          borderRadius: "12px",
          textAlign: "center",
          width: "280px",
          flexShrink: 0,
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          cursor: "pointer",
          boxSizing: "border-box",
          ...animationStyle, // Apply only if not mobile
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.05)";
          e.currentTarget.style.boxShadow =
            "0 10px 20px rgba(0, 0, 0, 0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
            <div
              style={{
                width: "100%",
                height: "200px",
                overflow: "hidden",
                borderRadius: "12px",
                backgroundColor: "#fff",
                marginBottom: "15px",
                padding: "15px",
                marginLeft: "5px",
                boxSizing: "border-box",
              }}
            >
              <img
                src={img}
                alt={titles[index]}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
            </div>

            <h3
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              {titles[index]}
            </h3>
            <p style={{ color: "#6B7280", fontSize: "14px" }}>
              {descriptions[index]}
            </p>
          </div>
        );
      })}
    </div>
  </div>
</>


   {/* <div
      style={{
        fontFamily: "Epilogue",
        lineHeight: "1.4",
        textAlign: "center",
        padding: "40px 20px",
        backgroundColor: "#fff",
      }}
    >
   <div
  style={{
    maxWidth: "600px",  // limit max width to control horizontal space
    margin: "0 auto",   // center horizontally
    padding: "0 20px",  // some horizontal padding for smaller screens
    textAlign: "center",
  }}
>
  <h2
    style={{
      fontSize: "28px",
      fontWeight: "bold",
      color: "#000",
      marginTop: "3px",
    }}
  >
    Latest blogs
  </h2>
  <p style={{ color: "#6B7280", fontSize: "16px", marginBottom: "30px" }}>
    Stay updated with our informative & inspired blog articles
  </p>
</div>


      <div
        style={{
          padding: "20px",
          fontFamily: "Inter, sans-serif",
        }}
      >
        <div
          className="blog-container"
          style={{
            display: "flex",
            gap: "32px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {posts.length === 0 && (
            <p style={{ fontStyle: "italic", color: "#6B7280" }}>
              Latest posts will appear here soon…
            </p>
          )}

          {posts.map(({ img, category, title, date, href }, i) => (
            <div
              key={i}
              style={{
                width: "320px",
                backgroundColor: "#FFF",
                border: "1px solid #E0E0E0",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                cursor: "pointer",
                transition: "transform .25s ease, box-shadow .25s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 16px rgba(0,0,0,0.08)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 4px rgba(0,0,0,0.04)";
              }}
              onClick={() => window.open(href, "_blank")}
            >
              <img
                src={img}
                alt={title}
                style={{ width: "100%", height: "180px", objectFit: "cover" }}
              />
              <div style={{ padding: "24px", textAlign: "left" }}>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    backgroundColor: "#EAF3FF",
                    color: "#0062FF",
                    fontSize: "12px",
                    fontWeight: 600,
                    borderRadius: "9999px",
                    padding: "4px 12px",
                    marginBottom: "16px",
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    fill="none"
                    stroke="#0062FF"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 8v4l2 2" />
                  </svg>
                  {category}
                </span>

                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: 700,
                    color: "#181835",
                    lineHeight: 1.3,
                    margin: "0 0 20px 0",
                  }}
                >
                  {title}
                </h3>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: "#6B7280",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    fill="none"
                    stroke="#6B7280"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <rect x="3" y="5" width="18" height="16" rx="2" />
                    <path d="M3 11h18M16 3v4M8 3v4" />
                  </svg>
                  <span>Posted on {date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <button
          style={{
            backgroundColor: "#fff",
            border: "1px solid #E5E5E5",
            color: "#2563EB",
            padding: "7px 50px",
            borderRadius: "100px",
            fontSize: "14px",
            fontWeight: "bold",
            cursor: "pointer",
            width: "100%",
            maxWidth: "205px",
            height: "54px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#EFF6FF";
            e.currentTarget.style.color = "#1D4ED8";
            e.currentTarget.style.border = "1px solid #BFDBFE";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#fff";
            e.currentTarget.style.color = "#2563EB";
            e.currentTarget.style.border = "1px solid #E5E5E5";
          }}
          onClick={() => window.open("https://blog.mawalog.com/", "_blank")}
        >
          View all
          <img
            src={right}
            alt="Arrow Icon"
            style={{ width: "16px", height: "16px" }}
          />
        </button>
      </div>

      <style>
        {`
          @media screen and (max-width: 1280px) {
            .blog-container {
              justify-content: center;
              padding-left: 10px;
              padding-right: 10px;
            }
          }

          @media screen and (max-width: 1024px) {
            .blog-container {
              gap: 24px !important;
            }
          }

          @media screen and (max-width: 768px) {
            h2 {
              font-size: 24px !important;
            }
            p {
              font-size: 14px !important;
              margin-bottom: 25px !important;
            }
            button {
              padding: 7px 40px !important;
              max-width: 180px !important;
              font-size: 13px !important;
              height: 48px !important;
            }
            .blog-container > div {
              width: 100% !important;
              max-width: 100% !important;
            }
          }

          @media screen and (max-width: 480px) {
            h2 {
              font-size: 20px !important;
              margin-top: 5px !important;
            }
            p {
              font-size: 13px !important;
              margin-bottom: 20px !important;
            }
            button {
              padding: 7px 30px !important;
              max-width: 160px !important;
              font-size: 12px !important;
              height: 44px !important;
              gap: 6px !important;
            }
            button img {
              width: 14px !important;
              height: 14px !important;
            }
            .blog-container > div {
              width: 100% !important;
            }
          }
        `}
      </style>
    </div> */}



  <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#0D0D2B",
    color: "#FFFFFF",
    padding: "50px 5%",
  }}
  className="industry-section"
>
  <div
    className="industry-left"
    style={{
      flex: "1",
      minWidth: "340px",
      maxWidth: "500px",
      textAlign: "start",
      borderRight: "1px solid #5F5A81",
    }}
  >
    <h2
      style={{
        fontSize: "24px",
        fontWeight: "bold",
        width: "472px",
        color: "#fff",
        marginTop: "-40px",
        marginLeft: "-20px",
      }}
    >
      Industry served
    </h2>
    <p
      style={{
        fontSize: "13px",
        color: "#B0B0C3",
        marginLeft: "-20px",
        lineHeight: "1.6",
        width: "390px",
        height: "59px",
      }}
    >
      This helps define the scope of a business, showcasing its expertise
      in specific fields. Companies often tailor their solutions to meet
      the unique challenges and needs of each industry.
    </p>
    <img
      src={factory}
      alt="Industry Illustration"
      style={{
        width: "369px",
        height: "246px",
        marginRight: "30px",
        marginTop: "10px",
      }}
    />
  </div>

  <div
    className="industry-right"
    style={{
      flex: "1.5",
      minWidth: "400px",
      maxWidth: "700px",
    }}
  >
    <h2
      style={{
        fontSize: "24px",
        fontWeight: "bold",
        color: "#fff",
        marginLeft: "20px",
        marginBottom: "20px",
      }}
    >
      Where you utilize Mawalog?
    </h2>

    <div
      className="industry-grid"
      style={{
        display: "grid",
        marginLeft: "30px",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "20px",
      }}
    >
      {[
        {
          title: "Technology & Software",
          desc: "Providing IT solutions, SaaS products, and digital transformation services.",
          img: n1,
        },
        {
          title: "Manufacturing",
          desc: "Supporting supply chain optimization, automation, and warehouse management.",
          img: n2,
        },
        {
          title: "Logistics",
          desc: "Supporting supply chain optimization, automation, and warehouse management.",
          img: n3,
        },
        {
          title: "Warehouse",
          desc: "Supporting supply chain optimization, automation, and warehouse management.",
          img: n4,
        },
        {
          title: "Educational Institutes",
          desc: "Used in colleges and schools for enhanced safety and security purposes.",
          img: n5,
        },
        {
          title: "Transportation",
          desc: "Supporting fleet management, ride-sharing, and smart mobility solutions.",
          img: n6,
        },
      ].map((item, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#181835",
            padding: "3px",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "8px",
            border: "1px solid #5F5A81",
            width: "303px",
            height: "100px",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.03)";
            e.currentTarget.style.border = "2px solid #8B5CF6";
            e.currentTarget.style.boxShadow =
              "0 4px 15px rgba(139, 92, 246, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.border = "1px solid #5F5A81";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img
              src={item.img}
              alt={item.title}
              style={{
                width: "30px",
                height: "30px",
                marginLeft: "10px",
                borderRadius: "5px",
              }}
            />
            <h3
              style={{
                fontSize: "13px",
                fontWeight: "bold",
                margin: 0,
                color: "#fff",
              }}
            >
              {item.title}
            </h3>
          </div>

          <p
            style={{
              fontSize: "11px",
              color: "#B0B0C3",
              margin: 0,
              paddingLeft: "10px",
            }}
          >
            {item.desc}
          </p>
        </div>
      ))}
    </div>
  </div>

  <style>
    {`
      /* Base padding tweaks for screens <= 1280px */
      @media screen and (max-width: 1280px) {
        .industry-section {
          padding: 50px 4%;
        }
        .industry-grid {
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        }
      }

      /* Tablet landscape and smaller laptops */
      @media screen and (max-width: 1024px) {
        .industry-left {
          border-right: none !important;
          margin-bottom: 30px;
          text-align: center !important;
        }

        .industry-right {
          margin-left: 0px;
        }

        .industry-grid {
          margin-left: 0px;
          gap: 15px;
        }
      }

      /* Smaller tablets and big phones in landscape */
      @media screen and (max-width: 900px) {
        .industry-section {
          flex-direction: column;
        }

        .industry-left,
        .industry-right {
          max-width: 100% !important;
        }
      }

      /* Mobile-first stacking with title first, then image, then right container */
      @media screen and (max-width: 480px) {
        .industry-left {
          border-right: none !important;
          margin: 0 0 20px 0 !important;
          text-align: center !important;
          min-width: 100% !important;
          max-width: 100% !important;
          order: 1;
        }

        .industry-left h2 {
          margin-left: 0 !important;
          margin-top: 0 !important;
          width: 100% !important;
          font-size: 20px !important;
        }

        .industry-left p {
          margin-left: 0 !important;
          width: 100% !important;
          height: auto !important;
          font-size: 12px !important;
        }

        .industry-left img {
          width: 100% !important;
          height: auto !important;
          margin: 10px 0 0 0 !important;
          margin-right: 0 !important;
        }

        .industry-right {
          order: 2;
          margin-left: 0 !important;
          min-width: 100% !important;
          max-width: 100% !important;
        }

        .industry-grid {
          margin-left: 0 !important;
          gap: 15px !important;
          grid-template-columns: 1fr !important;
          width: 100% !important;
        }
      }

      /* Additional fine tuning for tablet portrait (600px to 900px) */
      @media screen and (min-width: 481px) and (max-width: 900px) {
        .industry-left h2 {
          width: auto !important;
          font-size: 22px !important;
          margin-left: 0 !important;
          margin-top: 0 !important;
          text-align: center !important;
        }

        .industry-left p {
          width: auto !important;
          height: auto !important;
          font-size: 13px !important;
          margin-left: 0 !important;
          text-align: center !important;
        }

        .industry-left img {
          width: 80% !important;
          height: auto !important;
          margin: 15px auto 0 auto !important;
          display: block;
          margin-right: 0 !important;
        }

        .industry-right {
          margin-left: 0 !important;
          max-width: 100% !important;
        }

        .industry-grid {
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)) !important;
          margin-left: 0 !important;
          gap: 15px !important;
          width: 100% !important;
        }
      }
    `}
  </style>
</div>



 <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "60px",
    backgroundColor: "#fff",
    fontFamily: "Arial, sans-serif",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "0 auto",
    boxSizing: "border-box",
  }}
  className="benefit-section"
>
  <div
    className="benefit-left"
    style={{
      display: "flex",
      alignItems: "center",
      flex: "1",
      minWidth: "300px",
      marginBottom: "30px",
    }}
  >
    <div
      className="vertical-line"
      style={{
        width: "2px",
        height: "120px",
        backgroundColor: "#004BA8",
        borderRadius: "3px",
        marginRight: "10px",
        marginBottom: "60px",
      }}
    ></div>

    <div style={{ flex: "1", marginRight: "40px" }}>
      <div
        style={{
          fontSize: "36px",
          fontWeight: "bold",
          color: "#181835",
          textAlign: "start",
        }}
      >
        Benefits you will
        <br />
        experience with <br />
        <span style={{ color: "#004BA8" }}>Mawalog</span>
      </div>
      <p
        style={{
          color: "#B0B0C3",
          fontSize: "16px",
          marginTop: "20px",
          textAlign: "start",
        }}
      >
        You will receive efficiency, real-time tracking, and <br />
        personalized solutions from Mawalog.
      </p>
    </div>
  </div>

<div
  className="benefit-right"
  style={{
    flex: "1",
    maxWidth: isMobile ? "90%" : "600px",
    padding: "20px",
    borderRadius: "20px",
    border: "1px solid #E0E0E0",
    backgroundColor: "#FFFFFF",
    margin: "0 auto",
    boxSizing: "border-box",
    width: "100%",
  }}
>
  <div
    style={{
      fontSize: "20px",
      fontWeight: "bold",
      color: "#181835",
      textAlign: "start",
      marginBottom: "10px",
    }}
  >
    What you gonna earn from us
  </div>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
      gap: "20px",
      marginTop: "20px",
    }}
  >
    {[
      "Seamless Process Management",
      "Real-time Tracking",
      "User-friendly Interface",
      "Enhanced Productivity",
      "Secure & Reliable",
      "Customizable Solutions",
      "Comprehensive Analytics",
      "24/7 Support",
    ].map((text, index) => (
      <div
        key={index}
        style={{
          backgroundColor: "#F0F4FF",
          padding: "16px",
          borderRadius: "12px",
          textAlign: "center",
          fontSize: "14px",
          fontWeight: "bold",
          color: "#181835",
        }}
      >
        {text}
      </div>
    ))}
  </div>
</div>

<style>
  {`
    @media screen and (max-width: 1280px) {
      .benefit-section {
        padding: 50px 5%;
      }
    }

    @media screen and (max-width: 1024px) {
      .benefit-section {
        flex-direction: column;
        align-items: center; /* Center container on tablets */
        padding: 40px 5%;
        margin: 0 auto;
      }

      .benefit-left {
        flex-direction: column;
        align-items: center !important; /* Center left content */
      }

      /* Remove vertical line on tablets */
      .benefit-left .vertical-line {
        display: none;
      }

      .benefit-right {
        width: 100% !important;
        margin-top: 30px;
      }
    }

    @media screen and (max-width: 900px) {
      .benefit-left {
        margin-right: 0 !important;
      }

      .benefit-right h2 {
        margin-right: 0 !important;
      }

      .benefit-right {
        padding: 16px;
      }
    }

    @media screen and (max-width: 480px) {
      /* Remove vertical line on mobile as well */
      .benefit-left .vertical-line {
        display: none;
      }

      .benefit-section {
        align-items: center; /* Center container on mobile */
        margin: 0 auto;
        max-width: 90%;  /* reduce width a bit */
        padding-left: 10px;
        padding-right: 10px;
      }

      .benefit-left {
        align-items: center !important;
      }

      .benefit-right {
        margin: 0 auto; /* Center horizontally on mobile */
      }
    }
  `}
</style>

</div>







 {/* <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          padding: "clamp(30px, 5vw, 60px)",
          marginTop: screenWidth <= 1024 ? "clamp(20px, 4vw, 40px)" : "0",
        }}
      >
        <div
          style={{
            maxWidth: "clamp(800px, 90vw, 1200px)",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                color: "#181835",
                fontSize: "clamp(18px, 2.5vw, 22px)",
                fontWeight: "bold",
                paddingLeft:
                  screenWidth <= 1440
                    ? "clamp(50px, 10vw, 110px)"
                    : "clamp(100px, 12vw, 170px)",
                alignSelf: "flex-start",
              }}
            >
              Compliance of our company
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "clamp(10px, 2vw, 15px)",
                marginTop: "clamp(15px, 2vw, 20px)",
                flexWrap: "wrap",
              }}
            >
              {complianceData.slice(0, 3).map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#F4F7FF",
                    width: "clamp(200px, 30vw, 270px)",
                    height: "clamp(35px, 5vw, 40px)",
                    padding: "clamp(4px, 1vw, 5px)",
                    borderRadius: "30px",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    transition: "background-color 0.3s, transform 0.3s ease",
                    marginBottom:
                      screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#EDF4FF";
                    e.currentTarget.style.transform = "scale(1.03)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#F4F7FF";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        borderRadius: "50%",
                        padding: "clamp(8px, 1.5vw, 10px)",
                        marginRight: "clamp(8px, 1.5vw, 12px)",
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={item.title}
                        style={{
                          width: "clamp(30px, 4vw, 40px)",
                          height: "clamp(30px, 4vw, 40px)",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "#181835",
                        fontSize: "clamp(10px, 1.5vw, 12px)",
                        marginRight: "-10px",
                      }}
                    >
                      {item.title}
                    </span>
                  </div>
                  <img
                    src={riarr}
                    alt="Arrow"
                    style={{
                      width: "clamp(14px, 2vw, 18px)",
                      height: "clamp(14px, 2vw, 18px)",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "clamp(10px, 2vw, 15px)",
              marginTop: "clamp(15px, 2vw, 20px)",
              flexWrap: "wrap",
              marginRight:
                screenWidth <= 1024
                  ? "clamp(5px, 2vw, 10px)"
                  : "clamp(100px, 20vw, 290px)",
            }}
          >
            {complianceData.slice(3, 5).map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F4F7FF",
                  width: "clamp(200px, 30vw, 270px)",
                  height: "clamp(35px, 5vw, 40px)",
                  padding: "clamp(4px, 1vw, 5px)",
                  borderRadius: "30px",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  transition: "background-color 0.3s, transform 0.3s ease",
                  marginBottom:
                    screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#EDF4FF";
                  e.currentTarget.style.transform = "scale(1.03)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#F4F7FF";
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      borderRadius: "50%",
                      padding: "clamp(8px, 1.5vw, 10px)",
                      marginRight: "clamp(8px, 1.5vw, 12px)",
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={item.title}
                      style={{
                        width: "clamp(30px, 4vw, 40px)",
                        height: "clamp(30px, 4vw, 40px)",
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "#181835",
                      fontSize: "clamp(10px, 1.5vw, 12px)",
                      marginRight: "-10px",
                    }}
                  >
                    {item.title}
                  </span>
                </div>
                <img
                  src={riarr}
                  alt="Arrow"
                  style={{
                    width: "clamp(14px, 2vw, 18px)",
                    height: "clamp(14px, 2vw, 18px)",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div> */}

      <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          display: "flex",
          alignItems: "center",
          marginTop: "-20px",
          justifyContent: "center",
          backgroundColor: "#004BA8",
          padding: "clamp(20px, 3vw, 40px) clamp(40px, 5vw, 90px)",
          color: "#fff",
        }}
        className="newsletter-section"
      >
        <div
          style={{
            marginRight: "clamp(20px, 3vw, 40px)",
            marginBottom: "clamp(16px, 2vw, 20px)",
          }}
        >
          <img
            src={news}
            alt="Newsletter"
            style={{
              width: "clamp(150px, 20vw, 200px)",
              height: "clamp(120px, 15vw, 170px)",
              animation: "floatImage 3s ease-in-out infinite",
            }}
          />
        </div>

        <style>
          {`
      @keyframes floatImage {
        0% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
        100% { transform: translateY(0); }
      }

      @media (max-width: 480px) {
        .newsletter-section {
          flex-direction: column;
          text-align: center;
          padding: clamp(16px, 3vw, 24px) clamp(16px, 4vw, 24px);
        }
        .newsletter-section > div:first-child {
          margin-right: 0;
          margin-bottom: clamp(16px, 2vw, 20px);
        }
        .newsletter-section h2,
        .newsletter-section p,
        .newsletter-section > div > div,
        .newsletter-section > div > div:last-child {
          margin-left: 0;
        }
        .newsletter-section .newsletter-input {
          min-width: clamp(200px, 80vw, 260px);
        }
        .newsletter-section button {
        
          display: block;
        }
      }
    `}
        </style>

        <div className="newsletter-content">
          {/* Title and Paragraph */}
          <>
            <style>
              {`
      .newsletter-text {
        font-family: Epilogue;
        line-height: 1.4;
        font-size: 22px;
        margin-bottom: 10px;
        margin-left: 60px;
      }

      @media (max-width: 1024px) {
        .newsletter-text {
          font-size: 20px;
          margin-left: 50px;
        }
      }

      @media (max-width: 768px) {
        .newsletter-text {
          font-size: 18px;
          margin-left: 40px;
        }
      }

      @media (max-width: 480px) {
        .newsletter-text {
          font-size: 16px;
          margin-left: 30px;
        }
      }
    `}
            </style>

            <div className="newsletter-text">Subscribe to our Newsletter!</div>
          </>

          <>
            <style>
              {`
      .newsletter-description {
        font-size: 14px;
        margin-bottom: 20px;
        text-align: start;
        margin-left: 60px;
        max-width: 100%;
        box-sizing: border-box;
      }

      @media (max-width: 1024px) {
        .newsletter-description {
          font-size: 13px;
          margin-left: 50px;
        }
      }

      @media (max-width: 768px) {
        .newsletter-description {
          font-size: 12.5px;
          margin-left: 40px;
        }
      }

      @media (max-width: 480px) {
        .newsletter-description {
          font-size: 9px; /* reduced more for small screens */
          text-align: center;
      
        }
      }
    `}
            </style>

            <div className="newsletter-description">
              Stay updated with our latest news, offers, and insights! Subscribe{" "}
              <br />
              for exclusive updates delivered straight to your inbox.
            </div>
          </>

          
        <>
  <style>
    {`
      .input-wrapper {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: 0 auto 10px auto; /* center aligned */
        flex-wrap: nowrap;
      }

      .email-input {
        padding: 14px 16px 14px 48px;
        border-radius: 10px;
        border: 1px solid #9FCAFF;
        outline: none;
        background-color: #00377B;
        color: #fff;
        flex: 1;
        width: 100%;
        box-sizing: border-box;
        font-size: 16px;
      }

      .email-icon {
        position: absolute;
        left: 16px;
        width: 20px;
        height: 20px;
      }

      /* Optional: Keep consistent appearance on all devices */
      @media (max-width: 480px) {
        .email-input {
          padding: 12px 12px 12px 44px;
          font-size: 14px;
        }
      }
    `}
  </style>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      justifyContent: "center",
    }}
  >
    <div className="input-wrapper">
      <img src={mail} alt="Email Icon" className="email-icon" />
      <input
        type="email"
        value={email}
        placeholder="sample@gmail.com"
        className="email-input"
        onChange={handleChange}
      />
    </div>
  </div>
</>


         
          <>
            <style>{`
        .captcha-container {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 10px auto !important;
          border-radius: 20px !important;    
          gap: 8px !important;
          flex-wrap: wrap !important;
        }
      .captcha-box {
  width: 60px !important;
  height: 40px !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important; /* Add this to clip canvas overflow */
}

#captchaCanvas {
  border-radius: 20px !important;
}
        .captcha-input {
          padding:10px 1px!important;
          border-radius:8px!important;
          border:1px solid #ccc!important;
          outline:none!important;
          min-width:120px!important;
          background:#00377B!important;
          color:#fff!important;
        }
        .subscribe-button {
          padding:14px 30px!important;
          border-radius:12px!important;
          border:none!important;
          background:#fff!important;
          color:#0A3A72!important;
          font-weight:bold!important;
          cursor:pointer!important;
          margin-bottom:0!important;
        }
        @media(max-width:1024px){ .captcha-container{margin-left:50px!important;} .captcha-input{min-width:110px!important;} }
        @media(max-width:768px ){ .captcha-container{margin-left:40px!important;} .captcha-input{min-width:100px!important;} }
        @media(max-width:480px ){ .captcha-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captcha-input{min-width:80px!important;font-size:14px!important;} }
      `}</style>

            <div className="captcha-container">
              <div className="captcha-box">
                <canvas
                  ref={canvasRef}
                  id="captchaCanvas"
                  width={60}
                  height={40}
                />
              </div>

              <button
                onClick={handleReload}
                style={{
                  background: "#2563EB",
                  color: "#fff",
                  border: "none",
                  padding: "8px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Your reload SVG icon here */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button>

              <input
                type="text"
                placeholder="Enter captcha"
                value={userCaptcha}
                onChange={(e) => setUserCaptcha(e.target.value)}
                className="captcha-input"
              />

              <button className="subscribe-button" onClick={handleSubscribe}>
                Subscribe
              </button>
            </div>
          </>

          {/* Note */}
          <div
            style={{
              fontSize: "12px",
              marginTop: "10px",
              color: "#fff",
              marginLeft:
                window.innerWidth <= 480
                  ? "20px"
                  : window.innerWidth <= 768
                  ? "40px"
                  : window.innerWidth <= 1024
                  ? "50px"
                  : "60px",
            }}
          >
            *Unsubscribe anytime. We don’t send any spam
          </div>
        </div>
      </div>

     <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    justifyContent: "space-between",
    padding: isMobile ? "20px 10px" : "40px",
    backgroundColor: "#fff",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "0 auto",
    boxSizing: "border-box",
  }}
>
  <div
    style={{
      maxWidth: isMobile ? "100%" : isTablet ? "50%" : "300px",
      marginBottom: "40px",
    }}
  >
    <Link to="/">
      <img
        src={logo}
        alt="Mawalog"
        style={{
          width: isMobile ? "150px" : "180px",
          height: "auto",
          display: "flex",
          justifyContent: "start",
          cursor: "pointer"  // shows it's clickable
        }}
      />
    </Link>
    <p
      style={{
        color: "#555",
        fontSize: isMobile ? "12px" : "14px",
        lineHeight: "1.6",
        textAlign: "start",
        marginBottom: isMobile ? "20px" : "100px",
      }}
    >
      At Mawalog, we believe in simplifying the complexities of supply chain
      management by offering an integrated platform that combines manufacturing,
      logistics, and warehouse solutions partner with optimized logistics and a
      global network.
    </p>
    <div
      style={{
        display: "flex",
        gap: "12px",
        marginTop: isMobile ? "0" : "-80px",
      }}
    >
      {[insta, face, youtube, link,twit].map((icon, index) => (
        <img
          key={index}
          src={icon}
          alt={`icon-${index}`}
          style={{
            width: isMobile ? "20px" : "24px",
            height: isMobile ? "20px" : "24px",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            transformOrigin: "center",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.4)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "scale(1)")
          }
          onClick={() => {
            if (icon === face)
              window.open("https://www.facebook.com/mawalogone/", "_blank");
            if (icon === youtube)
              window.open("https://www.youtube.com/@mawalogone", "_blank");
            if (icon === insta)
              window.open("https://www.instagram.com/mawalogone/", "_blank");
            if (icon === link)
              window.open(
                "https://www.linkedin.com/company/mawalogone/",
                "_blank"
              )
              if (icon === twit)
              window.open("https://x.com/mawalogone", "_blank");
          }}
        />
      ))}
    </div>
  </div>

  <div
  style={{
    display: "flex",
    gap: isMobile ? "20px" : isTablet ? "40px" : "60px",
    flexWrap: "wrap",
    justifyContent: isMobile ? "flex-start" : "space-between",
  }}
>
  <div>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
      }}
    >
      Know More
    </h4>
{["Opportunities", "Articles", "Our Story", "Help Center"].map(
  (item, index) => (
    <p
      key={index}
      style={{
        margin: "8px 0",
        color: "#555",
        cursor: "pointer",
        textAlign: "start",
        fontSize: isMobile ? "12px" : "14px",
        transition: "color 0.3s ease",
        paddingBottom: "2px",
      }}
      onClick={() => {
        switch (item) {
          case "Opportunities":
          case "Articles":
          case "Help Center":
            navigate("/coming");
            break;
          case "Our Story":
            navigate("/about");
            break;
        }
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#3B82F6";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#555";
      }}
    >
      {item}
    </p>
  )
)}

  </div>

 <div>
      <h4
        style={{
          fontSize: isMobile ? "12px" : "14px",
          fontWeight: "bold",
          marginRight: isMobile ? "0" : "20px",
        }}
      >
        Legal &amp; Policies
      </h4>

 {[
  "Terms and Conditions",
  "Privacy Policy",
  "Cookie Policy",
  "Copyright Policy",
].map((item, index) => (
  <p
    key={index}
    style={{
      margin: "8px 0",
      color: "#555",
      cursor: "pointer",
      textAlign: "start",
      fontSize: isMobile ? "12px" : "14px",
      transition: "color 0.3s ease",
      paddingBottom: "2px",
    }}
    onClick={() => {
      const targetId = `#${item.toLowerCase().replace(/\s+/g, "-")}`;
      const basePath =
        item === "Terms and Conditions"
          ? "/terms"
          : item === "Privacy Policy"
          ? "/policy"
          : item === "Cookie Policy"
          ? "/cookie"
          : item === "Copyright Policy"
          ? "/copyright"
          : "/";
      navigate(`${basePath}${targetId}`);
    }}
    onMouseEnter={(e) => (e.currentTarget.style.color = "#3B82F6")}
    onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
  >
    {item}
  </p>
))}

    </div>

</div>


  <div style={{ marginBottom: "40px" }}>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
        marginRight: isMobile ? "0" : "180px",
      }}
    >
      Contact us
    </h4>
    <a
      href="https://mail.google.com/mail/?view=cm&to=info@mawalog.com"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#004BA8",
        cursor: "pointer",
        fontSize: isMobile ? "12px" : "14px",
        textAlign: "start",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src={ee}
        alt="Email"
        style={{
          width: isMobile ? "12px" : "14px",
          height: isMobile ? "12px" : "14px",
          marginRight: "8px",
        }}
      />
      info@mawalog.com
    </a>
    {[
      { phone: "603-27700-311", country: "Malaysia" },
      { phone: "+971-50-1234567", country: "UAE" },
      { phone: "+44 7911 123456", country: "UK" },
      { phone: "+91-44-4856-3345", country: "India" },
    ].map((contact, index) => (
      <p
        key={index}
        style={{
          fontSize: isMobile ? "12px" : "14px",
          textAlign: "start",
        }}
      >
        <img
          src={phone}
          alt="Phone"
          style={{
            width: isMobile ? "12px" : "14px",
            height: isMobile ? "12px" : "14px",
            marginRight: "8px",
          }}
        />
        <a
          href={`tel:${contact.phone}`}
          style={{
            color: "#004BA8",
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          {contact.phone}
        </a>{" "}
        (<span style={{ color: "#000" }}>{contact.country}</span>)
      </p>
    ))}
  </div>

  <div
    className="flex flex-col items-center justify-center p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-purple-700 text-white max-w-sm mx-auto shadow-lg"
    style={{ marginBottom: "40px", position: "relative" }}
  >
    <div style={{ position: "relative", display: "inline-block" }}>
      <a
        href="https://app.mawalog.com/register"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={trial}
          alt="Illustration"
          style={{
            width: isMobile ? "180px" : isTablet ? "200px" : "210px",
            height: "auto",
            display: "block",
            cursor: "pointer",
          }}
        />
      </a>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(130deg, transparent 48%, rgba(255,255,255,0.4) 50%, transparent 52%)",
            animation: "shine 3s ease-in-out infinite",
          }}
        ></div>
      </div>
    </div>
    <style>
      {`
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}
    </style>
  </div>
</div>


      <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          textAlign: "center",
          padding: "clamp(16px, 2vw, 20px) 0",
          borderTop: "1px solid #ddd",
          fontSize: "clamp(12px, 1.5vw, 14px)",
          color: "#333",
        }}
      >
        Copyright © 2025. <strong>MAWALOG</strong>. All Rights Reserved
      </div>
      {/* </motion.div> */}
    </div>
  );
};

export default Navbar;
